"use client";
import { useState, useEffect } from "react";
import UpArrowIcon from "./icons/upArrowIcon";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export default function ScrollToTopButton() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShowButton(scrollY > 1000); // Show button after scrolling 1000px
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`w-full left-0 flex justify-center fixed bottom-[25px] z-10 transition-opacity duration-350 ease-in-out ${
        showButton ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <button
        onClick={scrollToTop}
        className="bg-white px-16 py-4 rounded-full shadow-[0px_2px_8px_rgba(159,182,255,0.25)] transition-all duration-350 ease-in-out hover:bg-[#E2EFF8]"
      >
        <UpArrowIcon />
      </button>
    </div>
  );
}
